import axios from "axios";

export const exportBucketAllocationFile = async (id, token) => {
  try {
    const res = await axios.get(
      `portfolio/bucket-wise-allocation/${id}/?export=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

/*
export const deletePermission = async (id, token) => {
  try {
    const res = await axios.delete(
      `agency/admin/permissions-list/?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};
*/

export const deleteRules = async (id, token) => {
  try {
    const res = await axios.delete(
      `agency/admin/permissions-list/?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getEmployeeDetails = async (id, token) => {
  try {
    const res = await axios.get(
      `portfolio/employee-details/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};